import styles from './catalog-picker-modal.module.css'

import { RxInfoCircled } from '@react-icons/all-files/rx/RxInfoCircled'
import React from 'react'

import type { ClientLibraryId } from 'types/client-library'

import { Checkbox, Flex, Text } from 'components/ds'

import { CatalogImageOrFallback } from '../catalog-info-popover'
import { CatalogInfoPopover } from '../catalog-info-popover'
import type { PickerCatalog } from './types'
import { catalogName } from './utils'

type CatalogListProps = {
  catalogs: PickerCatalog[]
  selectedIds: ClientLibraryId[]
  onToggle: (id: ClientLibraryId) => void
  emptyMessage?: string
}

export const CatalogList = ({
  catalogs,
  selectedIds,
  onToggle,
  emptyMessage = 'No catalogs match your search.',
}: CatalogListProps) => {
  if (catalogs.length === 0) {
    return (
      <Text size="2" color="gray" as="p" className={styles.empty}>
        {emptyMessage}
      </Text>
    )
  }

  return (
    <Flex direction="column" role="list">
      {catalogs.map(catalog => {
        const name = catalogName(catalog)
        return (
          <Flex
            key={catalog.id}
            role="listitem"
            align="center"
            justify="between"
            gap="2"
            className={styles.row}
          >
            <Text as="label" size="2" className={styles.rowLabel}>
              <Flex align="center" gap="3">
                <Checkbox
                  checked={selectedIds.includes(catalog.id)}
                  onCheckedChange={() => onToggle(catalog.id)}
                />
                <CatalogImageOrFallback
                  imageUrl={catalog.image_logo_url}
                  name={name}
                  className={styles.avatar}
                />
                <Flex direction="column" className={styles.rowText}>
                  <Text weight="medium" translate="no" truncate>
                    {name}
                  </Text>
                  {catalog.short_description && (
                    <Text size="1" color="gray" translate="no" truncate>
                      {catalog.short_description}
                    </Text>
                  )}
                </Flex>
              </Flex>
            </Text>
            <CatalogInfoPopover
              source={{
                id: catalog.id,
                name,
                description: catalog.short_description ?? undefined,
                image_url: catalog.image_logo_url ?? undefined,
                url: catalog.public_url,
              }}
            >
              <button
                type="button"
                className={styles.infoIcon}
                aria-label={`About ${name}`}
              >
                <RxInfoCircled />
              </button>
            </CatalogInfoPopover>
          </Flex>
        )
      })}
    </Flex>
  )
}
